export default "__VITE_ASSET__D_mcM2Ee__"